import { render, staticRenderFns } from "./FinanceDashboard.vue?vue&type=template&id=32e1ef82"
import script from "./FinanceDashboard.vue?vue&type=script&lang=js"
export * from "./FinanceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports